export const messages = {
    titles: {
        nav: 'Connections',
        pageBannerSubtitle: 'Browse and edit Connections',
        pageBannerTitle: 'Connections',
    },
};
